module.exports = __webpack_public_path__ + "static/BalsamiqSans-Regular-d0e0c9d174a9cec8f1383ebd7bf51b31.ttf";